import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';
import { map, filter, reduce } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ListService {

	constructor(
		private http: MiraieService,
	) { }

	getUserList(first: { user_code: number, name: string } = undefined) {
		var url = "list/users";
		var list = [];

		if (first) {
			list.push(first);
		}
		return this.http.post(url, {});
		/*
		return this.http.post(url, {}).subscribe(
			(data: any[]) => {
				data.forEach(usr => {
					let info;
					info = { user_code: usr.user_code, name: usr.name + ' ' + usr.name2 };
					list.push(info);
				});
				return list;
			}
		);
		*/
	}

	getDivisionList(isShort = false, first: { division_code: number, division_name: string } = undefined) {
		var url = "list/divisions";
		var list = [];

		if (first) {
			list.push(first);
		}
		return this.http.post(url, {});
		/*
		return this.http.post(url, {}).subscribe(
			(data: any[]) => {
				data.forEach(div => {
					let info;
					if (isShort) {
						info = { division_code: div.division_code, division_name: div.division_shot_name };
					} else {
						info = { division_code: div.division_code, division_name: div.division__name };
					}
					list.push(info);
				});
				return list;
			}
		);
		*/
	}
	getCustomerList(user_code: number, status: { condition: string, value: string }) {
		var url = "list/customers";
		var list = [];

		var param = { user_code: user_code, status: status };
		return this.http.post(url, param);
	}
	getTodayEvents(division_code, year, month, day) {
		var url = "list/events";
		var list = [];

		var param = { division_code: division_code, year: year, month: month, day: day };
		return this.http.post(url, param);
	}
}
